import { auth } from 'data/firebase'

export const signIn = (email, password) =>
  auth.signInWithEmailAndPassword(email, password)

export const signOut = () =>
  auth.signOut()

export const signUp = (email, password) =>
  auth.createUserWithEmailAndPassword(email, password)

export const triggerPasswordReset = (email) =>
  auth.sendPasswordResetEmail(email)

export const updatePassword = (password) =>
  auth.currentUser.updatePassword(password)



// WEBPACK FOOTER //
// ./src/data/auth.js